import { useTeacherLicenseGet, useTeacherTestGet } from 'actions/teacher-license';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { teacherLicenseImportMapper } from './helpers';

const useLogic = () => {
  const { teacherId } = useParams();
  const {
    get: getTeacherLicense,
    data,
    isProcessing: isTeacherLicenseLoading,
  } = useTeacherLicenseGet(teacherId);

  const {
    get: getTeacherTests,
    data: teacherTestData,
    isProcessing: isTeacherTestLoading,
  } = useTeacherTestGet(teacherId);

  useEffect(() => {
    getTeacherLicense(teacherId);
    getTeacherTests(teacherId);
  }, [teacherId]);

  const { licenses, regions } = teacherLicenseImportMapper(data);

  return {
    tests: teacherTestData || [],
    licenses,
    regions,
    isLoading: isTeacherLicenseLoading || isTeacherTestLoading,
  };
};

export default useLogic;
